module.exports = __webpack_public_path__ + "img/c07_unitseer_Normal_ua.276df3ac.webp";